const AccountSettingsText =[
     {type: "typeOfTest",
          text1: "Test type determines when a test is given and lets you compare a student’s " +
               "knowledge of financial literacy before and after the course.",
          text1Class: "font-weight-normal",
          text2: "The selected test type " +
               "applies to all future tests. Students may take only one pre-test and one post-test. " +
               "If set to ‘mid-test,’ students may take the test multiple times. If set to ‘Test " +
               "Unavailable,’ students will not be able to take the test."
     },         

     {type: "gameTemplateText",
          text1: "Select Optional Game Templates (select all that apply):",
          text1Class: "font-weight-bold",
          text2: "The first time that players play the game, they must make their own choices " +
               "for job, home, furniture and car.  When they play subsequent times, you can " +
               "determine if they can play any of several 'game templates'.  A brief " +
               "description is provided for each of the templates listed below.  Unchecked templates " +
               "will not be available for players assigned to your account. You can change these " +
               "options at any time.  Removing a template option will not impact players who " +
               "may currently be using a template, but it will prevent players from choosing this " +
               "template for a new game.",
          
     },

]

export default AccountSettingsText;